import React from "react";

const Label = ({ variant }) => {
  const thermo = variant === "thermo";
  return (
    <figure className="flex flex-col items-center gap-3">
      <div
        className={`relative w-64 px-6 py-4 text-center shadow-lg ${
          thermo
            ? "rounded-md bg-white border-2 border-stone-200 [background-image:repeating-linear-gradient(45deg,transparent,transparent_6px,rgba(0,0,0,0.015)_6px,rgba(0,0,0,0.015)_12px)]"
            : "rounded-2xl bg-gradient-to-br from-orange-50 to-rose-50 border-2 border-orange-200"
        }`}
        data-testid={`label-mockup-${variant}`}
      >
        <p className="font-mono text-2xl font-black tracking-[0.2em] text-stone-900">AB3X-K9MZ</p>
        <p className="mt-1 font-bold text-sm text-orange-600">doudou-alert.fr</p>
      </div>
      <figcaption className="text-xs font-bold uppercase tracking-widest text-stone-500">
        {thermo ? "Étiquette thermocollante" : "Étiquette autocollante"}
      </figcaption>
    </figure>
  );
};

export const LabelMockup = () => (
  <div className="my-8 rounded-3xl border border-dashed border-orange-200 bg-white p-6 sm:p-8" data-testid="label-mockup">
    <div className="flex flex-wrap justify-center gap-8">
      <Label variant="thermo" />
      <Label variant="sticker" />
    </div>
    <p className="mt-6 text-center text-sm text-stone-500">
      Exemple : <strong>ligne 1</strong> = l'ID de votre doudou, <strong>ligne 2</strong> = doudou-alert.fr
    </p>
  </div>
);

export default LabelMockup;
